import { useState } from 'react';
import { listThemes } from '@secretnenshi/content';
import { DisclaimerText } from '../components/chrome';
import { Button, Page, Section } from '../components/ui';
import { chooseTheme, go, resumeSeat, showInfo } from '../state/actions';
import { forgetSeat, listSavedSeats } from '../state/storage';
import { useStore } from '../state/store';
import { useTheme } from '../theme/useTheme';

const THEMES = listThemes();

export function Landing() {
  const busy = useStore((s) => s.busy);
  const chosen = useStore((s) => s.themeId);
  const th = useTheme();
  const [seats, setSeats] = useState(listSavedSeats);

  return (
    <Page>
      <div className="hero">
        <p className="tagline">{th.t.tagline}</p>
      </div>

      {THEMES.length > 1 ? (
        <Section label="Choose your edition">
          <div className="theme-picker" role="radiogroup" aria-label="Edition">
            {THEMES.map((t) => (
              <button
                key={t.id}
                type="button"
                role="radio"
                aria-checked={chosen === t.id}
                className={`theme-option ${chosen === t.id ? 'selected' : ''}`}
                onClick={() => chooseTheme(t.id)}
              >
                <span className="theme-title">
                  <span className="theme-mark" aria-hidden="true">
                    ●
                  </span>
                  {t.title}
                  {t.status === 'preview' ? <span className="theme-badge">Preview</span> : null}
                </span>
                <span className="theme-edition">{t.editionName}</span>
                <span className="theme-desc">{t.menuDescription}</span>
              </button>
            ))}
          </div>
        </Section>
      ) : null}

      {seats.length > 0 ? (
        <Section label="Your games">
          {seats.map((s) => (
            <div className="rejoin" key={`${s.code}:${s.name}`}>
              <Button disabled={busy} onClick={async () => {
                if (!(await resumeSeat(s.code, s.name))) setSeats(listSavedSeats());
              }}>
                Rejoin game {s.code} as {s.name}
              </Button>
              <button
                type="button"
                className="link small"
                onClick={() => {
                  forgetSeat(s.code, s.name);
                  setSeats(listSavedSeats());
                }}
              >
                Forget
              </button>
            </div>
          ))}
        </Section>
      ) : null}

      <div className="stack">
        <Button onClick={() => go({ name: 'create' })}>Create game</Button>
        <Button variant="secondary" onClick={() => go({ name: 'join' })}>
          Join game
        </Button>
      </div>

      <nav className="links" aria-label="Information">
        <button type="button" className="link" onClick={() => showInfo('how-to-play')}>How to Play</button>
        <button type="button" className="link" onClick={() => showInfo('characters')}>Characters</button>
        <button type="button" className="link" onClick={() => showInfo('sources')}>Sources</button>
        <button type="button" className="link" onClick={() => showInfo('about')}>About</button>
        <button type="button" className="link" onClick={() => showInfo('disclaimer')}>Satire Disclaimer</button>
      </nav>

      <DisclaimerText />
    </Page>
  );
}
